var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssuiGlaceCasse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#221e23;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 essui glace cass\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1696.16,1370.85c8.26-20.13,13.38-32,20.25-44.17s78.9-104,78.9-104-11.33.39-7.37-7,75.74-108.88,84.61-111.62c7.38,7-5.45,25.62-62.55,101-4,5.33,4.15,10.29.17,15.55C1758.85,1288.35,1712.94,1349.4,1696.16,1370.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1758 1068 1848 1135 1932 1197 1937 1189 1766 1061 1758 1068"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssuiGlaceCasse);
export default __webpack_public_path__ + "static/media/essui_glace_casse.0ac05428e032b34ee76ddceded95b069.svg";
export { ForwardRef as ReactComponent };